// Google tag is loaded in public/index.html (Consent Mode v2); here we only manage consent + events
const KEY = "mb-cookie-consent";
const g = (...args) => { if (typeof window.gtag === "function") window.gtag(...args); };

export const gaEnabled = true;
export const getConsent = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

export function setConsent(value) {
  try { localStorage.setItem(KEY, value); } catch { /* ignore */ }
  g("consent", "update", { analytics_storage: value === "granted" ? "granted" : "denied" });
}

export function trackEvent(name, params = {}) {
  g("event", name, params);
}
